const DeleteIcon = (props) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            focusable="false"
            {...props}
        >
            <g clipPath="url(#clipDelete)">
                <path
                    d="M17.2861 18.6318C17.286 19.3843 16.6429 19.9999 15.8574 20H9.14258C8.35708 19.9999 7.71401 19.3843 7.71387 18.6318V10.4209H17.2861V18.6318ZM10.5 18H11.5V13H10.5V18ZM13.5 13V18H14.5V13H13.5ZM16.5 6.36816H19V8.7373H6V6.36816H8.5L9.21387 5H15.7861L16.5 6.36816Z"
                    fill="currentColor"
                />
            </g>
            <defs>
                <clipPath id="clipDelete">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default DeleteIcon;
